import React, {Component} from 'react';
import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

import {MainContent, Page, PageBody, PageHeader, SideNavigationBar} from '../../layout/components';
import {
  DashboardCharacterRow,
  FoundationOverview,
  FoundationOverviewDescription,
  FoundationOverviewVisual,
} from '../components';

import {
  loadDashboardCharacters,
  selectDashboardCharacter,
} from '../actions';
import {handleApiError} from '../../shared/services';

import {
  dashboardCharactersArraySelector,
  loadingSelector,
  selectedDashboardCharacterSelector,
} from '../selectors/pages/list';

class DashboardPage extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  handleCharacterClick(event) {
    const {dashboardCharacters, selectedDashboardCharacter, selectDashboardCharacter} = this.props;
    const id = Number.parseInt(event.currentTarget.dataset.id, 10);

    if (id !== selectedDashboardCharacter.get('id')) selectDashboardCharacter(dashboardCharacters.find(c => c.get('id') === id));
  }

  componentDidMount() {
    const {router} = this.props;
    this.props.loadDashboardCharacters()
      .catch(error => handleApiError(error, router, 'An error occurred while attempting to load the Dashboard Characters list.', 'Error'));
  }

  render() {
    const {
      loading,
      dashboardCharacters,
      selectedDashboardCharacter,
    } = this.props;

    const dividerStyle = {
      marginLeft: -30,
      marginRight: -30,
    };

    return (
      <Page pageClassName="dashboard-page">
        <PageHeader title="Dashboard" />
        <PageBody>
          <SideNavigationBar />
          <MainContent loading={loading}>
            <DashboardCharacterRow characters={dashboardCharacters.toArray()} onCharacterClick={this.handleCharacterClick} selectedDashboardCharacter={selectedDashboardCharacter} />
            <FoundationOverview>
              <FoundationOverviewDescription
                name={selectedDashboardCharacter.get('name')}
                title={selectedDashboardCharacter.get('foundationFull')}
                characterId={selectedDashboardCharacter.get('id')}
                pictogramItem={selectedDashboardCharacter.get('pictogramItem')}
                pictogramText={selectedDashboardCharacter.get('pictogramExplanation')}
                detailPagePath="#" />
              <FoundationOverviewVisual imageName={selectedDashboardCharacter.get('houseImageName')} />
            </FoundationOverview>
          </MainContent>
        </PageBody>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: loadingSelector(state),
    dashboardCharacters: dashboardCharactersArraySelector(state),
    selectedDashboardCharacter: selectedDashboardCharacterSelector(state),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    loadDashboardCharacters,
    selectDashboardCharacter,
  }
)(DashboardPage));



// WEBPACK FOOTER //
// ./app/features/dashboard/containers/DashboardPage.js